import apiClient from './apiClient';

  export const addCreditCard = async (creditCardData) => {
    try {        
      
      const token = localStorage.getItem('token');
      const response = await apiClient.post('CreditCard/Create', creditCardData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
    } catch (error) {
      //console.error('Profile creation failed:', error);
      //throw error;
    }
  };

  export const UpdateCreditCard = async (id, formData) => {
    try {
        const token = localStorage.getItem('token');
        
        const response = await apiClient.put(`CreditCard/update/${id}`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',  // Ensure JSON format
            }
        });

        return response.data;
    } catch (error) {
        console.error('Credit Card update failed:', error);
        throw error;
    }
};


  export const getCreditCards = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await apiClient.get('CreditCard/GetAll', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
    } catch (error) {
      //console.error('Fetching profile failed:', error);
      //throw error;
    }
  };


  export const getPanCardCustomer = async (panCardNo,createdBy) => {
    try {
      const token = localStorage.getItem('token');
      const response = await apiClient.get(`BasicCustomerDetails/by-panCardNo/${panCardNo}?createdBy=${createdBy}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Fetching customer details failed:', error);
      throw error;  // Optionally rethrow the error if you want it to propagate
    }
  };
  
  export const addBasicCustomer = async (basicCustomerData) => {
    try {        
      
      const token = localStorage.getItem('token');
      const response = await apiClient.post('BasicCustomerDetails', basicCustomerData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
    } catch (error) {
      //console.error('Profile creation failed:', error);
      //throw error;
    }
  };

  export const applyCreditCard = async (creditCardApplication) => {
    try {        
      
      const token = localStorage.getItem('token');
      const response = await apiClient.post('CreditCardApplication/create', creditCardApplication, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
    } catch (error) {
      //console.error('Profile creation failed:', error);
      //throw error;
    }
  };


  export const getApplyCreditCard = async (Id) => {
    try {        
        const token = localStorage.getItem('token');
        const response = await apiClient.get(`CreditCardApplication/getbycreatedby/${Id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
};

export const getAllCreditCard = async () => {
    try {        
        const token = localStorage.getItem('token');
        const response = await apiClient.get(`CreditCardApplication/getall`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
};


export const updateCreditCardStatus = async (id,updatedData) => {
  try {        
    
    const token = localStorage.getItem('token');
    const response = await apiClient.put(`CreditCardApplication/update/${id}`, updatedData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Profile creation failed:', error);
    //throw error;
  }
};